import { render, staticRenderFns } from "./UnitAutocomplete.vue?vue&type=template&id=01bc3d76"
import script from "./UnitAutocomplete.vue?vue&type=script&lang=ts"
export * from "./UnitAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bc3d76')) {
      api.createRecord('01bc3d76', component.options)
    } else {
      api.reload('01bc3d76', component.options)
    }
    module.hot.accept("./UnitAutocomplete.vue?vue&type=template&id=01bc3d76", function () {
      api.rerender('01bc3d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products-table/UnitAutocomplete.vue"
export default component.exports